import { Link } from 'react-router-dom';
import Modal from 'components/Modal';

export default function GenericAuthModal({ isOpen, onClose, compact = false, loginState = null, registrationState = null }) {
    return (
        <Modal open={isOpen} onClose={onClose} maxWidth={compact ? 'max-w-[460px]' : 'max-w-[580px]'} className="!w-full">
            <div className="flex w-full flex-col font-display">
                <h2 className={`w-full px-5 py-4 text-left font-black leading-tight text-white ${compact ? 'text-2xl sm:text-3xl' : 'text-3xl sm:text-4xl'}`}>
                    Hogyan folytatod?
                </h2>

                <div className={`grid gap-3 rounded-2xl bg-white p-4 text-neutral-900 shadow-2xl ${compact ? 'mx-2 mb-2 grid-cols-1' : 'w-full md:grid-cols-2 md:p-6'}`}>
                    <div className="flex flex-col justify-between gap-3 rounded-xl bg-sky-50 p-4">
                        <div className={`text-center font-black text-blue-500 ${compact ? 'text-xl' : 'text-2xl md:text-3xl'}`}>
                            Belépés
                        </div>

                        <div className="text-center text-sm font-semibold text-neutral-700 md:text-base">
                            Amennyiben már rendelkezel Fürge Diák fiókkal, kérjük, jelentkezz be
                        </div>

                        <Link 
                            to={'/bejelentkezes'}
                            state={loginState}
                            className="gradient-blue w-full rounded-lg py-3 text-center text-sm font-semibold text-white shadow-lg transition hover:-translate-y-0.5 hover:brightness-110 hover:shadow-xl md:text-base"
                        >
                            Belépés
                        </Link>
                    </div>

                    <div className="flex flex-col justify-between gap-3 rounded-xl bg-green-50 p-4">
                        <div className={`text-center font-black text-green-600 ${compact ? 'text-xl' : 'text-2xl md:text-3xl'}`}>
                            Regisztrálj most!
                        </div>

                        <div className="text-center text-sm font-semibold text-neutral-700 md:text-base">
                            Ha még nem rendelkezel Fürge Diák fiókkal, regisztrálj most
                        </div>
                        
                        <Link 
                            to={'/regisztracio'}
                            state={registrationState}
                            className="gradient-green w-full rounded-lg py-3 text-center text-sm font-semibold text-white shadow-lg transition hover:-translate-y-0.5 hover:brightness-110 hover:shadow-xl md:text-base"
                        >
                            Regisztráció
                        </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
